import { ChangeEvent } from "react";
import { TextField } from "@mui/material";
// Disabled with the iOS date/time padding override below — re-enable together.
// import { getIOSVersionGreaterThanDateTimeInputBreakingChange } from "../helpers/get-ios-version";

type TimeInputProps = {
  value: string | null;
  label?: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

export const GenericTextInput = (
  props: TimeInputProps & { type: "date" | "time" }
) => {
  const { value, onChange, type, label } = props;
  // NOTE: This override was added for an iOS 18.5 native date/time input bug
  // (commit f39b87f4c). On iOS 18.7 it over-inflates the field (forces
  // height:34px + marginTop:10px on top of MUI's content-box padding, ~77px
  // total vs the natural ~56px), so it now causes the oversized top/bottom
  // padding it was meant to fix. Disabled while we recalibrate / re-band the
  // version gate. See getIOSVersionGreaterThanDateTimeInputBreakingChange().
  const sx = {} as any;
  // const sx = getIOSVersionGreaterThanDateTimeInputBreakingChange()
  //   ? {
  //       ".MuiInputBase-formControl input": {
  //         height: "34px",
  //         marginTop: "10px",
  //       } as any,
  //     }
  //   : ({} as any);

  return (
    <TextField
      sx={sx}
      label={label}
      fullWidth
      margin="dense"
      type={type}
      value={value}
      onChange={onChange}
    />
  );
};

export const TimeInput = (props: TimeInputProps) => {
  return <GenericTextInput {...props} type="time" />;
};

export const DateInput = (props: TimeInputProps) => {
  return <GenericTextInput {...props} type="date" />;
};
